import React from "react";
import { useNavTree } from "../hooks/useNavTree";
import type { NavLocation } from "../types";
import { AppShell } from "./AppShell";
import { Navbar } from "./Navbar";
import { NavFlyout, NavTree } from "./NavTree";

import * as styles from "./NavRail.module.scss";

type NavRailProps = {
  location: NavLocation;
  inert?: boolean;
};

export const NavRail = ({ location, inert }: NavRailProps) => {
  const tree = useNavTree();

  return (
    <AppShell.Rail inert={inert}>
      <div className={styles.inset}>
        <Navbar.Root
          aria-label="Main"
          className={styles.card}
          flyoutClassName={styles.card}
          flyout={<NavFlyout tree={tree} location={location} />}
        >
          <NavTree tree={tree} location={location} />
        </Navbar.Root>
      </div>
    </AppShell.Rail>
  );
};
